export default __webpack_public_path__ + "static/media/DisneyMarvelSpiderman.39d177cd.jpg";